import { Link, useLocation, useRouter } from '@tanstack/react-router';

// If needed we can use here page `NotFoundErrorPage` from @mint-lib/error-boundary

const redirects = new Map<RegExp, string>([
  // [/set-password/, '/auth/set-password/'],
]);

export function NotFound() {
  const router = useRouter();

  // eslint-disable-next-line @mint/no-use-location
  const path = useLocation().pathname;

  for (const [pattern, redirect] of redirects) {
    if (pattern.test(path)) {
      router.navigate({
        ...router.state.location,
        to: redirect,
        replace: true,
      });

      return null;
    }
  }

  return (
    <div className="bg-muted flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="text-muted-foreground mb-4 text-xl">
          Oops! Page not found!
        </p>
        <Link to="/" className="text-primary hover:text-primary/90 underline">
          Return to Home
        </Link>
      </div>
    </div>
  );
}
